/** CoStar.Api.MarketAnalytics.SearchMarkets.Map.ShapeGeographyType */
export var ShapeGeographyType;
(function (ShapeGeographyType) {
    ShapeGeographyType[ShapeGeographyType["Submarket"] = 0] = "Submarket";
    ShapeGeographyType[ShapeGeographyType["BlockGroup"] = 21] = "BlockGroup";
    ShapeGeographyType[ShapeGeographyType["OutputArea"] = 22] = "OutputArea";
    ShapeGeographyType[ShapeGeographyType["DisseminationArea"] = 23] = "DisseminationArea";
})(ShapeGeographyType || (ShapeGeographyType = {}));
